/** My profile: language, contact, password and the person’s own settings — English, the source of the other languages */
const profile = {
  "profile.language": "Language",
  "profile.languageHint": "The language of the dashboard and of the messages you receive. “Same as the company” follows your company’s language.",
  "profile.sameAsCompany": "Same as the company",
  "profile.languageSaved": "Language saved",
  "profile.languageNotSaved": "Could not save the language",
  "profile.pwChanged": "Password changed",
  "profile.pwChangedText": "Every session has been signed out; this browser has signed in again.",
  "profile.pwFailed": "The password could not be changed",
  "profile.pwCheck": "Check your current password and try again.",
  "profile.vpnDownloaded": "VPN file downloaded",
  "profile.vpnDownloadedText": "Import the .ovpn file into your OpenVPN client.",
  "profile.downloadFailed": "Download failed",
  "profile.vpnNotYet": "The VPN file is not available yet.",
  "profile.title": "My profile",
  "profile.alertContact": "Alert contact",
  "profile.alertContactText": "Add a phone number in international format to receive outage alerts by WhatsApp or RCS.",
  "profile.appearance": "Appearance",
  "profile.theme.light": "Light",
  "profile.theme.dark": "Dark",
  "profile.default": "(default)",
  "profile.account": "Account",
  "profile.companyAdmin": "Company admin",
  "profile.teamMember": "Team member",
  "profile.permissions": { one: "{count} permission", other: "{count} permissions" },
  "profile.vpnAccess": "VPN access",
  "profile.lastSeen": "Last seen",
  "profile.downloadVpn": "Download the .ovpn file",
  "profile.vpnCreating": "Your VPN account is being created. This usually takes a few minutes.",
  "profile.noVpn": "No VPN account yet.",
  "profile.setup": "Setup instructions",
  "profile.changePw": "Change password",
  "profile.currentPw": "Current password",
  "profile.hidePw": "Hide password",
  "profile.showPw": "Show password",
  "profile.newPw": "New password",
  "profile.confirmPw": "Confirm password",
  "profile.updatePw": "Update password",
  "profile.phoneSaved": "Phone number saved",
  "profile.phoneSaveFailed": "The number could not be saved",
  "profile.codeSent": "Code sent",
  "profile.codeSentRcs": "Check the messages app on that phone (RCS).",
  "profile.codeSentWa": "Check WhatsApp on that number.",
  "profile.codeFailed": "No code could be sent",
  "profile.phoneVerified": "Phone number verified",
  "profile.verifyFailed": "Verification failed",
  "profile.phone": "Phone number",
  "profile.verified": "verified",
  "profile.notVerified": "not verified",
  "profile.save": "Save",
  "profile.sendAgain": "Send again",
  "profile.sendCode": "Send verification code",
  "profile.code": "Verification code",
  "profile.codePlaceholder": "6-digit code",
  "profile.verify": "Verify",
  "profile.verifiedOnly": "WhatsApp and RCS alerts are only sent to a verified number.",
  "profile.phoneApp": "Phone app",
  "profile.phoneAppAddress": "In the Velanox app, choose “Sign in to your own company” and scan this code, or type the address:",
  "profile.phoneAppSoon": "The app is coming to the App Store and Google Play.",
  "profile.phones": "Phones that stay signed in",
  "profile.noPhones": "No phone stays signed in.",
  "profile.thisPhone": "This phone",
  "profile.phoneAdded": "added {when}",
  "profile.phoneUsed": "last used {when}",
  "profile.removePhoneOf": "Remove {name}",
  "profile.removePhoneConfirm": "Remove {name}? It is signed out and asks for the password again.",
  "profile.phoneRemoved": "Phone removed",
  "profile.phoneRemoveFailed": "The phone was not removed",
  "profile.push.on": "Push: on",
  "profile.push.off": "Push: off",
  "profile.push.allow": "Allow push on this phone",
  "profile.push.turnOff": "Turn off push",
  "profile.push.denied": "Push is off in this phone's settings",
  "profile.push.refused": "Push was not allowed on this phone",
  "profile.push.shortages": "Rental shortages by push",
  "profile.push.shortagesHint": "Only your phones: the mail about shortages stays as it is.",
  "profile.push.notSaved": "Could not save the push setting",
  "profile.push.channel": "Alerts",
}

export default profile
